/** Безопасный вывод телефонов из БД (через запятую → с переносами), без падения при null/undefined. */
export function formatPhonesMultiline(phone: string | null | undefined): string {
  return String(phone ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .join("\n");
}
